export default __webpack_public_path__ + "static/media/serviceChecklist.626f3e1a.svg";